module.exports = __webpack_public_path__ + "assets/favicons/favicon-32x32.5e90fa5555b1aa7310d839cfa26b12bf.png";